import { ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_MAIRIE, ROLE_PUBLIC, ROLE_PILOT, ROLE_USER } from "@router/Routes"

const useRestrictRoute = () => {
  const routes = {
    ROLE_SUPER_ADMIN,
    ROLE_ADMIN,
    ROLE_MAIRIE,
    ROLE_PILOT
  }

  const isUserAuthorized = (scene, role) => {
    let isAuthorized = false
    const routesToCheck = { ...routes[role], ...ROLE_PUBLIC, ...ROLE_USER }
    Object.keys(routesToCheck).map(route => {
      if (!isAuthorized) {
        isAuthorized = scene === route
      }
    })

    return isAuthorized
  }

  return isUserAuthorized
}

export default useRestrictRoute